import React, { useId } from 'react';
import { Tooltip } from 'primereact/tooltip';
import './MetadataBadge.scss';

export type MetadataBadgeVariant = 'success' | 'danger' | 'secondary' | 'pending' | 'generating';

export interface MetadataBadgeProps {
  variant: MetadataBadgeVariant;
  text: string;
  tooltipText?: string;
  uniqueId?: string;
  pulse?: boolean;
}

export const MetadataBadge: React.FC<MetadataBadgeProps> = ({
  variant,
  text,
  tooltipText,
  uniqueId,
  pulse,
}) => {
  const generatedId = useId();
  const badgeId = uniqueId ?? `metadata-badge-${generatedId.replace(/:/g, '')}`;

  return (
    <>
      <span id={badgeId} className={`tag tag--stats tag--mention tag--badge-${variant}`}>
        <span className="tag__stripe" />
        <span className="tag__value">{text}</span>
        {pulse && <span className="metadata-badge__pulse" />}
      </span>
      {tooltipText && (
        <Tooltip target={`#${badgeId}`} content={tooltipText} position="top" showDelay={5} />
      )}
    </>
  );
};

export default MetadataBadge;
